/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * @file: 首页推荐卡片
 * @author: zhangjie13
 */
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import 'intersection-observer'; // polyfill
import { IVideo } from '@/schemas/video';
import { sendShow, sendClick, formatNumber } from '@utils/helpers';
import { openOrDownloadUrl } from '@utils/open-or-download-url';
import WebImage from '@/components/WebImage';
import LoadImage from '@assets/load-image.png';
import {
  compareAppVersion,
  getKwaiVersion,
  SUPPORT_SUBJECT_VER,
  inKsNebula
} from '@/utils/device';
import styles from './index.module.scss';

interface ISeriesCoverProps {
  video: IVideo;
  videoIndex: number;
}

const RecommendVideoCard = ({ video, videoIndex }: ISeriesCoverProps) => {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true
  });
  const isHotVideo = video.viewCount > 100 * 10000;

  useEffect(() => {
    if (inView) {
      sendShow('KWAI_HEALTHY_PHOTO_LIST', {
        index: `${videoIndex  }`,
        photo_id: `${video.photoId  }`,
        s_author_id: `${video.userId  }`
      });
    }
  }, [inView]);

  const handleClick = () => {
    sendClick('KWAI_HEALTHY_PHOTO_LIST', {
      index: `${videoIndex  }`,
      photo_id: `${video.photoId  }`,
      s_author_id: `${video.userId  }`
    });
    const singleVideoUrl = `kwai://work/${video.photoId}?userId=${video.userId}`;

    if (inKsNebula()) {
      openOrDownloadUrl(singleVideoUrl);
      return;
    }

    const kwaiVersion = getKwaiVersion();
    if (kwaiVersion) {
      if (compareAppVersion(kwaiVersion, SUPPORT_SUBJECT_VER) >= 0) {
        openOrDownloadUrl(video.ksUrl);
        return;
      }
    }
    openOrDownloadUrl(singleVideoUrl);
  };

  return (
    <div
      ref={ref}
      aria-hidden
      className={styles['recommend-video-card']}
      onClick={handleClick}
    >
      <div className={styles.cover}>
        <WebImage
          url={video.coverUrl}
          defaultImg={LoadImage}
          altStr={video.caption}
          isKcdnImg={false}
        />
      </div>
      <div className={styles['card-title']}>
        {isHotVideo && <i className={styles['hot-video']} />}
        {video.caption}
      </div>
      <div className={styles['video-info']}>
        <div className={styles.author}>
          <WebImage url={video.userHeaderUrl} isKcdnImg={false} />
          <p>{video.userName}</p>
        </div>
        <p className={styles['like-wrapper']}>
          <i />
          <span>{formatNumber(video.likeCount)}</span>
        </p>
      </div>
    </div>
  );
};

export default RecommendVideoCard;
